<script setup lang="ts">
import HelpeeCampaignSignUpView from './helpee-campaign-signup/HelpeeCampaignSignUpView.vue';
</script>

<template>
  <HelpeeCampaignSignUpView />
</template>
